<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('trainingplan.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <div id="gridTrainingplan">
                <kendo-datasource ref="datasourceTrainingplan"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourceTrainingplan'"
                            ref="grid"
                            :toolbar="['pdf']"
                            :mobile="true"
                            :pdf-all-pages="true"
                            :pdf-avoid-links="true"
                            :pdf-paper-size="'A4'"
                            :pdf-margin="{ top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' }"
                            :pdf-landscape="true"
                            :pdf-repeat-headers="true"
                            :pdf-file-name="$t('trainingplan.Header')"
                            :pdf-title="$t('trainingplan.Header')"
                            :pdf-scale="0.8">
                    <kendo-grid-column :field="'Wochentag'"
                                       :title="$t('trainingplan.GridColumnHeaderWeekday')"
                                       :minResizableWidth="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Datum'"
                                       :title="$t('trainingplan.GridColumnHeaderDate')"
                                       :minResizableWidth="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Zeit'"
                                       :title="$t('trainingplan.GridColumnHeaderTime')"
                                       :minResizableWidth="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Trainer'"
                                       :title="$t('trainingplan.GridColumnHeaderTrainer')"
                                       :minResizableWidth="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Thema'"
                                       :title="$t('trainingplan.GridColumnHeaderTopic')"
                                       :minResizableWidth="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Hinweise'"
                                       :title="$t('trainingplan.GridColumnHeaderNotes')"
                                       :minResizableWidth="200">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
    </div>
</template>

<script>
    import $ from 'jquery';
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                config: config,
                theImage: '',
                schemaModelFields: {
                    Wochentag: { validation: { required: true } },
                    Datum: { validation: { required: true } },
                    Zeit: { validation: { required: true } },
                    Trainer: { validation: { required: true } },
                    Thema: { validation: { required: true } },
                    Hinweise: { validation: { required: true } }
                }
            }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            const grid = this.$refs.grid.kendoWidget();
            $.each(grid.columns, function (index, column) {
                grid.resizeColumn(column, column.minResizableWidth);
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TrainingsplanAnzeige"
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>